const viteEnv = typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env : undefined;
const browserEnv = typeof window !== 'undefined' ? window.__SNAP_ENV__ : undefined;

function getEnvVar(name) {
  const viteKey = `VITE_${name}`;
  if (viteEnv && viteEnv[viteKey] !== undefined) {
    return viteEnv[viteKey];
  }
  if (browserEnv && browserEnv[viteKey] !== undefined) {
    return browserEnv[viteKey];
  }
  const legacyKey = `REACT_APP_${name}`;
  if (typeof process !== 'undefined' && process.env && process.env[legacyKey] !== undefined) {
    return process.env[legacyKey];
  }
  return undefined;
}

export const API_URL = getEnvVar('API_URL');
export const STATIC_URL = getEnvVar('STATIC_URL');
export const MISC_FILES_URL = getEnvVar('MISC_FILES_URL') || STATIC_URL;
export const FRONT_URL = getEnvVar('FRONT_URL');
export const WS_URL = getEnvVar('WS_URL');
// Set true to show signup again.
export const TRIAL_SIGNUP_ENABLED = false;

const toNumber = (value) => {
  if (value === '' || value === null || value === undefined) {
    return undefined;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
};

export const MAX_UPLOAD_SIZE_MB = toNumber(getEnvVar('MAX_UPLOAD_SIZE_MB'));
export const MAX_MEDIA_DURATION_MINUTES = toNumber(getEnvVar('MAX_MEDIA_DURATION_MINUTES'));
// Helper function to check organization-level feature flags
export const isFeatureEnabledForOrg = (feature, user) => {
  if (!user?.Organization?.metadata?.feature_flags) {
    return false;
  }
  return Boolean(user.Organization.metadata.feature_flags[feature]);
};

// Specific helper for training paths
export const isTrainingPathsEnabledForOrg = (user) => {
  return isFeatureEnabledForOrg('training_paths', user);
};

export const MEETING_STATUSES = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
};

export const DISPLAY_STATUSES = {
  'in progress': 'Processing',
  published: 'Ready to share',
  draft: 'Draft',
};

export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  USER: 'user',
};

export const MEETING_TABS = {
  MY_VIDEOS: 'my videos',
  MOBILE_UPLOADS: 'mobile uploads',
  SAVED: 'saved',
};

export const ORG_ROLES = {
  OWNER: 'owner',
  MANAGER: 'manager',
  VIEWER: 'viewer',
};

// Training Path Status Constants
export const TRAINING_PATH_STATUSES = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export const TRAINING_PATH_ASSIGNMENT_STATUSES = {
  ASSIGNED: 'assigned',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  APPROVED: 'approved',
  CANCELED: 'canceled',
};

// Training Path Status Labels (for display)
export const TRAINING_PATH_STATUS_LABELS = {
  // Training Path statuses
  [TRAINING_PATH_STATUSES.ACTIVE]: 'Active',
  [TRAINING_PATH_STATUSES.INACTIVE]: 'Inactive',
  // Assignment statuses
  [TRAINING_PATH_ASSIGNMENT_STATUSES.ASSIGNED]: 'Assigned',
  [TRAINING_PATH_ASSIGNMENT_STATUSES.IN_PROGRESS]: 'In Progress',
  [TRAINING_PATH_ASSIGNMENT_STATUSES.COMPLETED]: 'Completed',
  [TRAINING_PATH_ASSIGNMENT_STATUSES.APPROVED]: 'Approved',
  [TRAINING_PATH_ASSIGNMENT_STATUSES.CANCELED]: 'Canceled',
};

// Helper function to get formatted status label
export const getTrainingPathStatusLabel = (status) => {
  if (!status) return '';
  return TRAINING_PATH_STATUS_LABELS[status] || status;
};

// Helper function to get status token for CSS data-status attribute
// Converts 'in_progress' -> 'in-progress', 'assigned' -> 'assigned', etc.
export const getTrainingPathStatusToken = (status) => {
  if (!status) return '';
  return status.toString().toLowerCase().replace(/[_\s]+/g, '-');
};
